import { formEmbed } from './formEmbed.js';

formEmbed();
